import {Field} from 'formik'
import React, {ReactEventHandler, memo, useEffect, useRef, useState} from 'react'
import OTPInput from './OTPInput'
import {showToast} from '../../../auth/components/middleware/showToast'
import Swal from 'sweetalert2'
import {useNavigate} from 'react-router-dom'
import {reSendOtp} from '../../../auth/components/server/OTP'

type LayoutProps = {
  numberPhone?: string
  changeOTPEvent: ReactEventHandler
  isError?: boolean
  hasCountDown?: boolean
  expiredOtp?: string
  resendOtp?: boolean
  // handleResendOtp?: any
  currentStep?: any
  valueSteps?: any
  checkOtpSucc?: any
  emptyOtp?: boolean
}

const Step3 = ({
  changeOTPEvent,
  isError,
  expiredOtp,
  hasCountDown = true,
  resendOtp = true,
  // handleResendOtp,
  currentStep,
  valueSteps,
  checkOtpSucc,
  emptyOtp,
}: LayoutProps) => {
  const initialMinute = 0,
    initialSeconds = 59
  const [minutes, setMinutes] = useState(0)
  const [seconds, setSeconds] = useState(59)
  const [count, setCount] = useState(1)
  const history = useNavigate()

  const handleResendOtp = async () => {
    await reSendOtp({
      mobile: valueSteps?.phoneNumber,
    })
  }

  useEffect(() => {
    if (hasCountDown) {
      let myInterval = setInterval(() => {
        if (seconds > 0) {
          setSeconds(seconds - 1)
        }
        if (seconds === 0) {
          if (minutes === 0) {
            clearInterval(myInterval)
          } else {
            setMinutes(minutes - 1)
            setSeconds(59)
          }
        }

        if (!resendOtp && minutes === 0 && seconds === 0) {
          handleResendOtp()
        }
      }, 1000)
      return () => {
        clearInterval(myInterval)
      }
    }
  }, [minutes, seconds])

  const handleResendOtps = async () => {
    handleResendOtp()
    setMinutes(initialMinute)
    setSeconds(initialSeconds)
    setCount(count + 1)
    if (count === 6) {
      Swal.fire({
        html: `Quý khách đã vượt quá số lần nhận OTP. Vui lòng thử lại sau 24h kể từ thời điểm bị khóa.`,
        allowOutsideClick: false,
        icon: 'error',
        confirmButtonText: 'Đã hiểu',
      }).then((result) => {
        if (result.isConfirmed) {
          history('/auth')
        }
      })
    }
  }

  return (
    <div className='w-100'>
      <div className='pb-5 pb-lg-5'>
        <h2 className='fw-bolder text-primary text-center'>Nhập mã OTP</h2>
      </div>
      <div className='text-center pb-lg-5'>
        <span className='d-block'>Vui lòng nhập mã OTP được gửi tới số điện thoại </span>
        <span className='d-block fw-bold'>{valueSteps?.phoneNumber} </span>
      </div>

      <div className={`d-flex align-items-center justify-content-center w-full my-6`}>
        <OTPInput
          autoFocus
          isNumberInput
          length={6}
          className={`d-flex `}
          inputClassName={`${isError ? 'otp-error' : ''} ${
            checkOtpSucc ? 'otp-success' : ''
          } form-control w-40px mx-1 text-center`}
          onChangeOTP={(otp: any) => changeOTPEvent(otp)}
          emptyOtp={emptyOtp}
        />
      </div>
      {isError && (
        <div className='my-4 text-center'>
          Mã OTP bạn nhập <span className='fw-bolder text-danger'>chưa chính xác</span>
          <p>Xin vui lòng kiểm tra lại.</p>
        </div>
      )}

      {hasCountDown && (
        <>
          {minutes === 0 && seconds === 0 ? (
            <div className='text-center' style={{marginTop: '12px'}}>
              Không nhận được mã OTP?
              <button
                className='text-primary bg-none border-0'
                disabled={count > 6}
                onClick={handleResendOtps}
                style={{background: 'none'}}
              >
                {resendOtp ? 'Gửi lại OTP' : ''}
              </button>
            </div>
          ) : (
            <>
              <div
                className='form-text text-center'
                style={{marginTop: '5px', display: 'flex', justifyContent: 'center'}}
              >
                <p>Hết hạn trong: </p>
                <span className='text-primary fw-bold' style={{marginLeft: '2px'}}>
                  {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
                </span>
              </div>
            </>
          )}
        </>
      )}
    </div>
  )
}

const OTP = memo(Step3)

export default OTP
